import { type RefObject, useId } from 'react';
import Card from '@rio-cloud/rio-uikit/Card';
import { DriverChatUpsellingButton } from './DriverChatUpsellingButton';
import { useDriverChatMessages } from './useDriverChatMessages';

type Props = {
    viewRef: RefObject<HTMLDivElement | null>;
    trackingCategory: string;
};

export const CampaignDView = ({ viewRef, trackingCategory }: Props) => {
    const titleId = useId();
    const { message } = useDriverChatMessages();

    return (
        <div ref={viewRef} className='height-100pct overflow-y-auto bg-white padding-25'>
            <Card className='max-width-350 margin-auto border-none' padding={25} shadow='none'>
                <section aria-labelledby={titleId} className='display-grid gap-10 text-center'>
                    <header className='display-grid gap-10 justify-content-center'>
                        <span className='uikit-icon icon-chat text-size-h1 text-color-primary' aria-hidden='true' />
                        <h1
                            id={titleId}
                            className='text-size-h1 text-medium text-color-darkest line-height-125rel text-wrap-balance margin-0'
                            style={{ textTransform: 'none' }}
                        >
                            Driver chat
                        </h1>
                    </header>
                    <div className='display-grid gap-15 justify-content-center padding-top-20 padding-bottom-25'>
                        <p className='text-size-18 text-color-dark line-height-125rel text-wrap-balance margin-0'>
                            {message('compact.intro')}
                        </p>
                        <p className='text-size-18 text-color-dark line-height-125rel text-wrap-balance margin-0'>
                            {message('compact.booking')}
                        </p>
                    </div>
                    <DriverChatUpsellingButton trackingCategory={trackingCategory} block />
                </section>
            </Card>
        </div>
    );
};
